import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Pixel',
    entityNamePlural: 'Pixels',
    entityNameModule: 'path',
    filters: { active: true },
  }), [])
}
